import React, {Fragment, Component} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Grid, Hidden,
} from '@material-ui/core';

import {cancelDeleteUser} from '../../vendors/actions/user'
import {AvatarUpload} from '../../component';
import {EditInfoView, ChangePassword, EditCreditCard} from './elements';
import {toggleUserEdit, userUpdated} from '../../vendors/actions/layout'
import {PencilIcon, DeleteIcon} from '../../elements/svgIcons'
import {NotificationBox} from "../../elements/notificationBox";
import Info from "./elements/info";

interface OwnProps {
    toggleUserEdit?: any,
    Layout?: any
}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        avatar: string,
        email: string
    },
    UserEditForm: {
        valid: boolean
    }
}

interface ConnectDispatchProps {
    toggleUserEdit?: (data: any) => void;
    deleteUser: (data: any) => void;
    userUpdated: (data: boolean) => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class Profile extends Component<HeaderProps> {
    componentWillUnmount(): void {
        this.props.Layout.editUser && this.props.toggleUserEdit(false);
    }

    componentDidUpdate(prevProps: Readonly<HeaderProps>): void {
        if (prevProps.Layout.userUpdated !== this.props.Layout.userUpdated) {
            setTimeout(() => this.props.userUpdated(false), 3000)
        }
    }

    toggleEdit = (e: any) => {
        e.preventDefault();
        this.props.toggleUserEdit(this.props.User)
    };

    render() {
        const userUpdated = this.props.Layout.userUpdated,
            editUser = this.props.Layout.editUser
        return (
            <Fragment>
                <Hidden smUp>
                    {userUpdated &&
                    <Grid item xs={12} md={8}>
                        <NotificationBox severity={"success"}
                                         text={"Your profile details have been updated successfully!"}/>
                    </Grid>}
                </Hidden>
                <Grid container className='profile justify-content-center'>
                    <Grid item xs={12} md={10} lg={8} xl={6}
                          className={`profile-container d-sm-flex mb-4 px-4 px-sm-1 pt-5 ${editUser ? 'pb-5' : 'pb-4'} pb-sm-5 rounded text-white`}>
                        {!editUser &&
                        <PencilIcon className='profile-edit' onClick={(e) => this.toggleEdit(e)}/>}
                        {editUser &&
                        <div onClick={() => {
                            this.props.deleteUser(true)
                        }}
                             className='profile-delete'>
                            <DeleteIcon/> Delete Account
                        </div>}
                        <Grid item className='profile-avatar' xs={12} sm={6}>
                            <AvatarUpload/>
                        </Grid>
                        <Grid item className='profile-info' xs={12} sm={6}>
                            {editUser ? <EditInfoView/> : <Info/>}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className='justify-content-center spacing-md-4' spacing={3}>
                    <Grid className='payment' item xs={12} md={5} lg={4} xl={3}>
                        <EditCreditCard/>
                    </Grid>
                    <Grid className='password' item xs={12} md={5} lg={4} xl={3}>
                        <ChangePassword/>
                    </Grid>
                </Grid>
                <Hidden smDown>
                    {userUpdated &&
                    <Grid container className='d-flex justify-content-center'>
                        <Grid item xs={8} className='mt-5'>
                            <NotificationBox severity={"success"}
                                             text={"Your profile details have been updated successfully!"}/>
                        </Grid>
                    </Grid>}
                </Hidden>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Error, Layout, UserEditForm} = state;
    return {
        User,
        Error,
        Layout,
        UserEditForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        toggleUserEdit: (data: any) => dispatch(toggleUserEdit(data)),
        deleteUser: (data: any) => dispatch(cancelDeleteUser(data)),
        userUpdated: (data: boolean) => dispatch(userUpdated(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



